import React from 'react';
import METHOD_NAMES from './methodNames';

function PaymentLogo({ brand, className, large }) {
  const name = METHOD_NAMES[brand];
  const baseClasses = name
    ? `card-logo card-logo--${name}`
    : fallbackIconClasses(large);

  return <span className={baseClasses + (className ? ` ${className}` : '')} />;
}

function fallbackIconClasses(large) {
  return (
    'svg-icon svg-icon--payment' + (large ? ' svg-icon--payment-large' : '')
  );
}

export default PaymentLogo;
